export default __webpack_public_path__ + "assets/f29635e61989fd6b325e5a0ec56398b3.svg";